<sub-header [isModal]="true" [windowHash]=windowHash></sub-header>
<div [style]="{width: '100%', height: '100vh'}" styleClass="custombar1" *ngIf="isLoaded()">
  <div class="container-fluid m-b-lg" *ngIf="isLoaded()">
    <div class="row">
      <form autocomplete="off">
        <div class="form-group col-12 ">
          <p-editor *ngIf="!standaloneControl" inputId="htmlEditor" name="htmlEditor" [(ngModel)]="context.text"
            class="plForm-element" [modules]="editorModules">
            <p-header *ngIf="context.isabled">
            </p-header>
            <p-header *ngIf="!context.disabled">
              <ng-container *ngTemplateOutlet="editorToolbar"></ng-container>
            </p-header>
          </p-editor>
        </div>
      </form>
    </div>
  </div>
</div>
<ng-template #editorToolbar>
  <span class="ql-formats">
    <button  type="button" class="ql-header" value="1" data-placement="bottom" title="{{ 'HtmlEditor.header' | translate}} 1"
      aria-label="{{ 'HtmlEditor.header' | translate}} 1"></button>
    <button type="button" class="ql-header" value="2" data-placement="bottom" title="{{ 'HtmlEditor.header' | translate}} 2"
      aria-label="{{ 'HtmlEditor.header' | translate}} 2"></button>
    <select class="ql-size" data-placement="bottom" title="{{ 'HtmlEditor.size.description' | translate}}"
      aria-label="{{ 'HtmlEditor.size.description' | translate}}">
      <option value="huge">{{ 'HtmlEditor.size.huge' | translate}}</option>
      <option value="large">{{ 'HtmlEditor.size.large' | translate}}</option>
      <option selected>{{ 'HtmlEditor.size.normal' | translate}}</option>
      <option value="small">{{ 'HtmlEditor.size.small' | translate}}</option>
    </select>
  </span>
  <span class="ql-formats">
    <button class="ql-bold" data-toggle="tooltip" data-placement="bottom" title="{{ 'HtmlEditor.bold' | translate}}"
      aria-label="{{ 'HtmlEditor.bold' | translate}}" type="button"></button>
    <button class="ql-italic" data-placement="bottom" title="{{ 'HtmlEditor.italic' | translate}}"
      aria-label="{{ 'HtmlEditor.italic' | translate}}" type="button"></button>
    <button class="ql-underline" data-placement="bottom" title="{{ 'HtmlEditor.underline' | translate}}"
      aria-label="{{ 'HtmlEditor.underline' | translate}}" type="button"></button>
    <button class="ql-strike" data-placement="bottom" title="{{ 'HtmlEditor.strike' | translate}}"
      aria-label="{{ 'HtmlEditor.strike' | translate}}" type="button"></button>
    <select class="ql-color" data-placement="bottom" title="{{ 'HtmlEditor.color' | translate}}"
      aria-label="{{ 'HtmlEditor.color' | translate}}"></select>
    <select class="ql-background" data-placement="bottom" title="{{ 'HtmlEditor.background' | translate}}"
      aria-label="{{ 'HtmlEditor.background' | translate}}"></select>
    <button class="ql-script" value="sub" data-placement="bottom" title="{{ 'HtmlEditor.sub-script' | translate}}"
      aria-label="{{ 'HtmlEditor.sub-script' | translate}}" type="button"></button>
    <button class="ql-script" value="super" data-placement="bottom" title="{{ 'HtmlEditor.super-script' | translate}}"
      aria-label="{{ 'HtmlEditor.super-script' | translate}}" type="button"></button>
    <button class="ql-code" data-placement="bottom" title="{{ 'HtmlEditor.code' | translate}}"
      aria-label="{{ 'HtmlEditor.code' | translate}}" type="button"></button>
  </span>
  <span class="ql-formats">
    <button class="ql-list" value="ordered" data-placement="bottom" title="{{ 'HtmlEditor.ordered' | translate}}"
      aria-label="{{ 'HtmlEditor.ordered' | translate}}" type="button"></button>
    <button class="ql-list" value="bullet" data-placement="bottom" title="{{ 'HtmlEditor.bullet' | translate}}"
      aria-label="{{ 'HtmlEditor.bullet' | translate}}" type="button"></button>
    <button class="ql-indent" value="-1" data-placement="bottom" title="{{ 'HtmlEditor.indent-minus' | translate}}"
      aria-label="{{ 'HtmlEditor.indent-minus' | translate}}" type="button"></button>
    <button class="ql-indent" value="+1" data-placement="bottom" title="{{ 'HtmlEditor.indent-add' | translate}}"
      aria-label="{{ 'HtmlEditor.indent-add' | translate}}" type="button"></button>
    <select class="ql-align" data-placement="bottom" title="{{ 'HtmlEditor.align' | translate}}"
      aria-label="{{ 'HtmlEditor.align' | translate}}">
      <!-- Note a missing, thus falsy value, is used to reset to default -->
      <option selected></option>
      <option value="center"></option>
      <option value="right"></option>
      <option value="justify"></option>
    </select>
    <button class="ql-blockquote" data-placement="bottom" title="{{ 'HtmlEditor.blockquote' | translate}}"
      aria-label="{{ 'HtmlEditor.blockquote' | translate}}" type="button"></button>
    <button class="code-block" data-placement="bottom" title="{{ 'HtmlEditor.code-block' | translate}}"
      aria-label="{{ 'HtmlEditor.code-block' | translate}}" type="button"></button>
  </span>
  <span class="ql-formats">
    <button class="ql-image" data-placement="bottom" title="{{ 'HtmlEditor.image' | translate}}"
      aria-label="{{ 'HtmlEditor.image' | translate}}" type="button"></button>
    <button class="ql-link" data-placement="bottom" title="{{ 'HtmlEditor.link' | translate}}"
      aria-label="{{ 'HtmlEditor.link' | translate}}" type="button"></button>
  </span>
  <span class="ql-formats">
    <button class="ql-clean" data-placement="bottom" title="{{ 'HtmlEditor.clean' | translate}}"
      aria-label="{{ 'HtmlEditor.clean' | translate}}" type="button"></button>
  </span>
</ng-template>